import { Injectable } from '@angular/core';
import { DefaultLocalStorageService } from 'angular-auth-oidc-client';

export function refreshStoredJwksUrl(value: string, cacheKey: string): string {
  try {
    const stored = JSON.parse(value) as {
      authWellKnownEndPoints?: { jwksUri?: string };
    };
    const endpoints = stored.authWellKnownEndPoints;
    const jwksUri = endpoints?.jwksUri;
    if (!endpoints || !jwksUri) return value;

    const url = new URL(jwksUri);
    url.searchParams.set('cache', cacheKey);
    endpoints.jwksUri = url.toString();
    return JSON.stringify(stored);
  } catch {
    return value;
  }
}

@Injectable()
export class OidcLocalStorageService extends DefaultLocalStorageService {
  private readonly jwksCacheKey = Date.now().toString(36);

  override read(key: string): string | null {
    const value = super.read(key);
    return value ? refreshStoredJwksUrl(value, this.jwksCacheKey) : null;
  }
}
